import { combineReducers } from 'redux';

import setup from './setup/reducer';
import runner from './runner/reducer';

export default combineReducers({
    setup, runner
});
